/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { PearlApiDocumentVersionType } from '../features/sharedcomponents/chat/chatSlice';
import { RootState } from '../app/store';
import pearlApi from '../features/sharedcomponents/api/pearlApi';
import { DocumentVersionType } from '../features/sharedcomponents/algorithm/types';
import { convertPearlApiDocumentVersionToDocumentVersionType } from '../features/sharedcomponents/chat/convertPearlApiDocumentVersionToDocumentVersion';

type ApiResponse = {
  consultant_review: {
    id: string;
    consultant_email: string;
    consultant_name: string;
    doc_version_id: string;
    created_at: string;
    url: string;
    can_comment?: boolean;
  };
  doc_version: PearlApiDocumentVersionType;
};
export const fetchDocumentForExternalReviewThunk = createAsyncThunk<
  { documentVersion: DocumentVersionType; consultant_reviewer_info: ApiResponse['consultant_review'] },
  { doc_version_id: string; review_id: string },
  { state: RootState }
>('externalReview/fetchDocumentForExternalReviewThunk', async ({ doc_version_id, review_id }) => {
  try {
    const response = await pearlApi.get<{ data: ApiResponse }>(
      `/documentVersions/${doc_version_id}/consultant-reviews/${review_id}`
    );
    const { consultant_review, doc_version } = response.data.data;
    const refinedDocumentVersion: DocumentVersionType = await convertPearlApiDocumentVersionToDocumentVersionType(
      doc_version
    );
    return {
      documentVersion: refinedDocumentVersion,
      consultant_reviewer_info: { ...consultant_review, can_comment: consultant_review.can_comment ?? true },
    };
  } catch (error) {
    throw new Error('Failed to fetch document for external review');
  }
});
